import React, { useCallback, useEffect, useRef, useState } from "react";
import Update from "./Update";
import * as serviceWorker from "../../serviceWorker";
import { useLocation } from "react-router-dom";

const hasWaiting = (registration) => {
  if (registration && registration.waiting) {
    return true;
  } else {
    return false;
  }
};

const isShowPage = (location) => {
  if (
    location.pathname === "/input" ||
    location.pathname === "/login" ||
    location.pathname === "/logout" ||
    location.pathname === "/forgot"
  ) {
    return false;
  } else {
    return true;
  }
};

export default function CacheBuster() {
  const [show, setShow] = useState(false);
  const regRef = useRef(null);
  const location = useLocation();

  const config = {
    onUpdate: (registration) => {
      if (hasWaiting(registration)) {
        regRef.current = registration;
        setShow(true);
      }
    },
  };

  const update = useCallback(() => {
    if (regRef.current) {
      regRef.current.waiting.postMessage({ type: "SKIP_WAITING" });

      regRef.current.waiting.addEventListener("statechange", (e) => {
        if (e.target.state === "activated") {
          window.location.reload();
        }
      });
    }
  }, []);

  useEffect(() => {
    serviceWorker.register(config);

    if (location.pathname === "/login") update();
  }, [config, location, update]);

  const handleUpdate = useCallback(() => {
    setShow(false);

    if (hasWaiting(regRef.current)) {
      update();
    }
  }, [update]);

  return (
    <>
      {isShowPage(location) ? (
        <Update show={show} onUpdate={handleUpdate} />
      ) : null}
    </>
  );
}
